/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { SxProps } from '@mui/material';

export const headerMiniCartButtonSX: SxProps = {
	flex: 1,
	textAlign: 'center',
};

export const headerMiniCartTermsTextSX: SxProps = {
	color: 'grey.200',
	display: 'flex',
	gap: '3px',
};

export const headerMiniCartTermsLinkSX: SxProps = {
	color: 'secondary.main',
	textDecoration: 'none',
	fontSize: 'inherit',
	'&:hover': {
		color: 'secondary.main',
		textDecoration: 'none',
	},
};
